import isEmpty from 'lodash-es/isEmpty';
import usePlotDevicesIds from './usePlotDevicesIds';
const usePlotDevicesCount = (plot) => {
    const deviceIds = usePlotDevicesIds(plot);
    return !isEmpty(deviceIds) ? deviceIds.length : null;
};
export default usePlotDevicesCount;
